var styles = [".header-image[_ngcontent-%COMP%]{height:400px}.header-title[_ngcontent-%COMP%]{margin-bottom:56px}@media (max-width:767.98px){.header-image[_ngcontent-%COMP%]{height:256px}.header-title[_ngcontent-%COMP%]{margin-bottom:24px}}"];
export { styles as styles };
